<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-row>

                    <lg-form-input sm="10" invalidFeedback="Informe o início do tombamento" description=""
                        v-model="tombamento" label="Tombamento:" />

                    <b-button @click="printTomb" id="btn-header-imprimir" size="sm" pill variant="success">
                        <b-icon icon="printer" />
                    </b-button>
                    <b-tooltip target="btn-header-imprimir" title="Imprimir todos..." />


                </b-row>

                <b-form-row @keyup.enter="load">
                    <lg-form-input sm="2" invalidFeedback="Informe o início do tombamento" description=""
                        v-model="form.numTombamento" label="Tombamento:" />

                    <lg-form-input sm="2" invalidFeedback="Informe o fim do tombamento" description=""
                        v-model="form.numTombamentoAte" label="Até:" />

                    <lg-form-date sm="2" invalidFeedback="A data de deve ser informada!" description=""
                        v-model="form.dataDe" label="Entrada:" />
                    <lg-form-date sm="2" invalidFeedback="A data limite deve ser informada!" description=""
                        v-model="form.dataAte" label="Até:" />

                    <lg-form-input invalidFeedback="Informe um tombamento válido" description="" sm="4"
                        v-model="form.numTombamentoSamp" label="Tombamento SAMP:" />


                    <b-col lg="4" sm="12" class="text-left">

                        <LgFinderPageUnidadeAdministrativa id="finderDepartamentoIBP" v-model="form.departamento"
                            @notInUnidadeAdministrativa="manageNotInUnidadeAdministrativa"
                            @selecionarOrnograma="selecionarOrnograma" @onselect="departamentoSelect"
                            :podeMudarDepartamento="podeMudarDepartamento" :codsDepartamentos="codsDepartamentos"
                            :podeApagarDepartamento="podeMudarDepartamento"
                            :mostrarNotInUnidadeAdministrativa="verificaPrivilegioGerenciarPatrimonio()"
                            :ornograma="verificaPrivilegioGerenciarPatrimonio()" :prefix="prefix + title + ' > '">
                        </LgFinderPageUnidadeAdministrativa>
                    </b-col>


                    <lg-form-input sm="4" invalidFeedback="Informe uma descrição válida" description=""
                        v-model="form.descricaoProduto" label="Descrição:" />

                    <b-col lg="4" sm="12" class="text-left">
                        <b-col cols="12" class="text-left">
                            <b-form-checkbox v-model="form.descricaoExata" :value="true" :unchecked-value="false">
                                Descrição exata
                            </b-form-checkbox>
                        </b-col>

                    </b-col>

                    <b-col lg="4" sm="12" class="text-left">
                        <LgFinderPageStatus v-model="form.status" id="finderPageStatus" @input="selectStatus"
                            :prefix="[prefix, title]" label="Status:" cols="12" />
                    </b-col>

                    <b-col lg="7" sm="12" class="text-left">
                        <img @click="gerarRelatorioGeralPdf()" :src="pdf" alt="PDF" class="mx-1"
                            style="width:32px;cursor:pointer" v-b-tooltip.hover.top="'Gerar Relatório PDF'" />

                    </b-col>


                </b-form-row>

                <b-form-row>
                    <b-col cols="12" class="text-right">
                        <b-button id="LimparIbp" class="mr-2 my-2" size="sm" style="height: 20px" pill variant="primary"
                            @click="clearForm">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="eraser" />
                            </div>
                            <b-tooltip target="LimparIbp" title="Limpar" triggers="hover"></b-tooltip>
                        </b-button>

                        <b-button id="pesquisaIbp" class="mr-2 my-2" size="sm" style="height: 20px" pill
                            variant="primary" @click="load()">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" />
                            </div>
                            <b-tooltip target="pesquisaIbp" title="Localizar" triggers="hover"></b-tooltip>
                        </b-button>
                    </b-col>
                </b-form-row>
            </b-card>

            <b-card bg-variant="light">
                <b-table id="tabelaItem" responsive class="mt-2" small :busy="this.busy" :items="this.records"
                    :fields="this.tableFields" :hover="true" show-empty>

                    <template v-slot:head(action)>
                        <b-button v-if="verificaPrivilegioImprimirTodos()" @click="abrirModalImprimirTodos"
                            id="btn-header-imprimir" size="sm" pill variant="success">
                            <b-icon icon="printer" />
                        </b-button>
                        <b-tooltip target="btn-header-imprimir" title="Imprimir todos..." />
                    </template>

                    <template v-slot:cell(action)="row">
                        <b-button v-if="verificaPrivilegioImprimir() && !row.item.dataImpressao"
                            :id="row.index + 'imprimir'" class="my-2" size="sm" pill variant="success"
                            @click="showModal(row.item)">
                            <b-icon icon="printer" />
                            <b-tooltip :target="row.index + 'imprimir'" title="Imprimir..."></b-tooltip>
                        </b-button>

                        <b-button v-if="verificaPrivilegioAlterarStatus() && row.item.status == 'I'"
                            :id="row.index + 'falha'" class="my-2" size="sm" pill variant="danger"
                            @click="falha(row.item)">
                            <b-icon icon="exclamation-octagon" />
                            <b-tooltip :target="row.index + 'falha'" title="Apontar falha na impressão..."></b-tooltip>
                        </b-button>

                        <b-button v-if="verificaPrivilegioReImprimir() && row.item.status == 'F'"
                            :id="row.index + 'reimprimir'" class="my-2" size="sm" pill variant="success"
                            @click="showModal(row.item)">
                            <b-icon icon="printer" />
                            <b-tooltip :target="row.index + 'reimprimir'" title="Reimprimir..."></b-tooltip>
                        </b-button>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <template #empty>
                        <p>Nenhum resultado encontrado</p>
                    </template>
                </b-table>
                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>

        <b-modal :title="prefix + title + ' > Impressão'" hide-footer v-if="mostrarModal" v-model="mostrarModal"
            size="xl" button-size="sm" @hide="fecharModal" @hidden="fecharModal">

            <b-row>
                <b-row>
                    <b-col cols="5"></b-col>
                    <b-col cols="6">
                        <img v-if="etiquetaSrc" :src="etiquetaSrc"
                            style=" width: 600px !important; max-height: 100px !important; border: 1px solid black;border-radius: 40px; " />
                    </b-col>

                </b-row>

            </b-row>

            <lg-form-input v-if="status == 'F'" invalidFeedback=" " description="" v-model="justificativa"
                label="Justificativa:*" />


            <lg-form-input v-if="!imprimirTodos" disabled invalidFeedback=" " description="" v-model="tombamento"
                label="Tombamento:" />

            <LgFinderPageImpressora @input="setStatus" label="Impressora:*"
                :prefix="prefix + title + ' > Impressão' + ' > '" :model="impressora">
            </LgFinderPageImpressora>


            <b-form-row>

                <b-col cols="3"></b-col>
                <b-col cols="6" class="text-center">
                    <b-button v-if="status != 'F'" id="imprimir" class=" my-2" size="sm" pill variant="success"
                        @click="imprimir">
                        <b-icon icon="check-circle" />
                        <b-tooltip target="imprimir" title="Imprimir"></b-tooltip>

                    </b-button>
                    <b-button v-if="status == 'F'" id="rebtnimprimir" class=" my-2" size="sm" pill variant="success"
                        @click="reimprimir">
                        <b-icon icon="check-circle" />
                        <b-tooltip target="rebtnimprimir" title="Reimprimir"></b-tooltip>

                    </b-button>


                    <b-button id="cancelarImpressao" class=" my-2 ml-2" size="sm" pill variant="danger"
                        @click="fecharModal">
                        <b-icon icon="x-circle" />
                        <b-tooltip target="cancelarImpressao" title="Cancelar"></b-tooltip>

                    </b-button>
                </b-col>
                <b-col cols="3"></b-col>

            </b-form-row>


        </b-modal>
    </b-card>
</template>
<script>

import PdfIcon from "@/core/assets/icons/pdf.png";
import LgFinderPageStatus from '@/components/Finders/LgFinderPageStatus.vue'
import LgFinderPageUnidadeAdministrativa from '@/components/Finders/LgFinderPageUnidadeAdministrativa.vue'
import ResourceService from "@/core/api/ResourceService"
import LgFormDate from "@/core/components/Form/LgFormDate.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import ConfirmMixin from "@/core/mixins/confirm"
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource"
import moment from "moment"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import LgFinderPageImpressora from "@/components/Finders/LgFinderPageImpressora.vue";
import DownloadArquivoService from "@/core/utils/DownloadArquivoUtil";
export default {
    name: "ItemBemPermanenteList",
    components: {
        LgFinderPageUnidadeAdministrativa,
        LgFormInput,
        LgFormDate,
        LgFinderPageStatus,
        LgFinderPageImpressora
    },
    mixins: [ConfirmMixin, ListResourceMixin, FormResourceMixin],

    props: {
        podeMudarDepartamento: {
            type: Boolean,
            default: true
        },
        prefix: {
            tipe: String,
            default: "",
        },
        podePegarBloqueado: {
            type: Boolean,
            default: false,
        }
    },
    beforeMount() {
        this.$service = new ResourceService(`/api/itembempermanente-impressaoetiqueta`)
        this.$statusService = new ResourceService(`/api/status/tipo/6`)
        this.$serviceStatus = new ResourceService(`/api/status`)
        this.$serviceImpressora = new ResourceService(`/api/impressora`)

        const brand = JSON.parse(localStorage.getItem("context"))
        this.form.departamento = brand.departamento
        this.params.departamentoId = brand.departamento.id

        this.load()

    },
    data() {
        return {
            pdf: PdfIcon,

            imprimirTodos: false,
            etiquetaSrc: '',
            status: "",
            justificativa: "",
            impressora: {},
            tombamento: "",
            codsDepartamentos: "",
            selecionarTodos: false,
            mostrarModal: false,
            idItemBemPermanente: null,
            isEdit: false,
            IbpSelecionado: null,
            params: {},
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            filtro: "",
            title: this.$route.meta.description,
            form: {
                notInUnidadeAdministrativa: false,
                incluirFilhos: 1,
                pessoa: {},
                pessoas: [],
                produto: {},
                produtos: [],
                id: "",
                s_numTombAntigo: "",
                descricaoProduto: "",
                tipoestadoconservacao: {},
                dataDe: "",
                dataAte: "",
                notaFiscal: "",
                status: {},
                numTombamento: "",
                numTombamentoSamp: "",
                departamento: {},
                numero: "",
                descricaoExata: false,

            },
        }
    },

    watch: {
        page() {
            this.load()
        },

    },
    computed: {
        departamentoFromStore() {
            return this.$store.getters.getMenuDepartamento
        },
        tableFields() {
            return [
                {
                    key: "action",
                    label: " ",
                    thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },

                {
                    key: "numTombamento",
                    label: "Tombamento",
                    thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: (value, index, item) => {

                        return item.status == 'F' ? "text-danger p-1" : "p-1"
                    },
                },
                {
                    key: "s_numTombAntigo",
                    label: "Tombamento SAMP",
                    thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: (value, index, item) => {

                        return item.status == 'F' ? "text-danger p-1" : "p-1"
                    },

                },
                {
                    key: "numero",
                    label: "Número",
                    thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: (value, index, item) => {

                        return item.status == 'F' ? "text-danger p-1" : "p-1"
                    },
                },
                {
                    key: "descricaoResumida",
                    label: "Descrição",
                    thStyle: "font-size: 14px; font-weight: 400; max-width: 100px !important",
                    tdStyle: "font-size: 13px; max-width: 100px !important",
                    tdClass: (value, index, item) => {

                        return item.status == 'F' ? "text-danger p-1" : "p-1"
                    },

                },
                {
                    key: "dataImpressao",
                    label: "Data de impressão",
                    formatter: data =>
                        data
                            ? moment(data, "YYYY-MM-DDTHH:mm:ss").format("DD/MM/YYYY HH:mm:ss")
                            : "",

                    thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: (value, index, item) => {

                        return item.status == 'F' ? "text-danger p-1" : "p-1"
                    },

                },
                {
                    key: "pessoaImprimiu",
                    label: "Usuário que imprimiu",
                    thStyle: "font-size: 14px; font-weight: 400; max-width: 100px !important",
                    tdStyle: "font-size: 13px; max-width: 100px !important",
                    tdClass: (value, index, item) => {

                        return item.status == 'F' ? "text-danger p-1" : "p-1"
                    },

                },
                {
                    key: "dataReimpressao",
                    label: "Data de Reimpressão",
                    formatter: data =>
                        data
                            ? moment(data, "YYYY-MM-DDTHH:mm:ss").format("DD/MM/YYYY HH:mm:ss")
                            : "",

                    thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: (value, index, item) => {

                        return item.status == 'F' ? "text-danger p-1" : "p-1"
                    },

                },
                {
                    key: "pessoaReimprimiu",
                    label: "Usuário que reimprimiu",
                    thStyle: "font-size: 14px; font-weight: 400; max-width: 100px !important",
                    tdStyle: "font-size: 13px; max-width: 100px !important",
                    tdClass: (value, index, item) => {

                        return item.status == 'F' ? "text-danger p-1" : "p-1"
                    },

                },
                {
                    key: "justificativa",
                    label: "Justificativa",
                    thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: (value, index, item) => {

                        return item.status == 'F' ? "text-danger p-1" : "p-1"
                    },
                },

            ]
        },
    },
    methods: {


        async gerarRelatorioGeralPdf() {

            this.busy = true
            this.gerarFiltro();

            try {
                const resource = new ResourceService('/api/relatorio/gerar-relatorio-impressao-etiqueta');
                const { data } = await resource.getWithParams('PDF', this.params);
                DownloadArquivoService(data.arquivoBase64, data.nomeArquivo);
            } finally {
                this.busy = false;
            }
        },

        async printTomb() {
            try {
                await this.$serviceImpressora.put(`imprimir-tombamento/41`, { tombamento: this.tombamento });
                this.$notify({
                    type: "success",
                    message: `Etiqueta impressa com sucesso`,
                });

            }
            catch (error) {
                this.$notify({
                    type: "danger",
                    message: error.response.data,
                });

            }


        },

        abrirModalImprimirTodos() {
            this.imprimirTodos = true;
            this.mostrarModal = true;


        },
        async gerarImagemEtiqueta() {
            const { data: zpl } = await this.$serviceImpressora.get(
                `gerar-etiqueta/${this.idItemBemPermanente}`
            );

            const res = await fetch("http://api.labelary.com/v1/printers/8dpmm/labels/4x6/0/", {
                method: "POST",
                headers: {
                    "Accept": "image/png",
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                body: zpl
            });

            if (!res.ok) {
                throw new Error("Erro ao gerar preview: " + res.status);
            }

            const blob = await res.blob();
            const img = new Image();
            img.src = URL.createObjectURL(blob);

            img.onload = () => {
                const canvas = document.createElement("canvas");
                canvas.width = 400;
                canvas.height = 100;
                const ctx = canvas.getContext("2d");

                ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, 400, 1000);

                this.etiquetaSrc = canvas.toDataURL("image/png");
            };
        },

        setStatus(impressora) {
            this.impressora = impressora;
        },
        async falha(item) {

            try {
                await this.$serviceImpressora.put(`falha/${item.id}`, this.justificativa);
                this.$notify({
                    type: "success",
                    message: `Status alterado com sucesso`,
                });

                this.load();

            }
            catch (error) {
                this.$notify({
                    type: "danger",
                    message: error.response.data,
                });

            }


        },
        async reimprimir() {

            if (!this.justificativa || this.justificativa == "") {

                this.$notify({
                    type: "danger",
                    message: `É necessário digitar uma justificativa`,
                });

                return;

            }

            if (!this.impressora || !this.impressora.id) {

                this.$notify({
                    type: "danger",
                    message: `É necessário escolher uma impressora para realizar a impressão`,
                });

                return;
            }

            try {
                await this.$serviceImpressora.put(`reimprimir/${this.impressora.id}/${this.idItemBemPermanente}`, { justificativa: this.justificativa });
                this.$notify({
                    type: "success",
                    message: `Etiqueta reimpressa com sucesso`,
                });
                this.fecharModal();

            }
            catch (error) {
                this.$notify({
                    type: "danger",
                    message: error.response.data,
                });

            }


        },
        async imprimir() {

            if (!this.impressora || !this.impressora.id) {

                this.$notify({
                    type: "danger",
                    message: `É necessário escolher uma impressora para realizar a impressão`,
                });
                this.fecharModal();
                return;
            }

            try {

                if (this.imprimirTodos) {
                    this.gerarFiltro();
                    await this.$serviceImpressora.put(`imprimir-etiqueta-todas/${this.impressora.id}`, this.params);

                }
                else {
                    await this.$serviceImpressora.put(`imprimir/${this.impressora.id}/${this.idItemBemPermanente}`, {});
                }
                this.$notify({
                    type: "success",
                    message: `Etiqueta impressa com sucesso`,
                });

            }
            catch (error) {
                this.$notify({
                    type: "danger",
                    message: error.response.data,
                });

            }


        },

        verificaPrivilegioImprimirTodos() {
            return verificaPrivilegio(PrivilegiosEnum.IMPRESSAO_ETIQUETA_IMPRIMIR_TODOS)
        },

        verificaPrivilegioImprimir() {
            return verificaPrivilegio(PrivilegiosEnum.IMPRESSAO_ETIQUETA_IMPRIMIR)
        },

        verificaPrivilegioAlterarStatus() {
            return verificaPrivilegio(PrivilegiosEnum.IMPRESSAO_ETIQUETA_ALTERAR_STATUS)
        },
        verificaPrivilegioReImprimir() {
            return verificaPrivilegio(PrivilegiosEnum.IMPRESSAO_ETIQUETA_REIMPRIMIR)
        },

        selecionarOrnograma(departamentos) {

            this.codsDepartamentos = departamentos;
            this.load();
        },
        verificaPrivilegioGerenciarPatrimonio() {
            return verificaPrivilegio(PrivilegiosEnum.GERENCIAR_PATRIMONIO)
        },

        manageNotInUnidadeAdministrativa(notInUnidadeAdministrativa) {
            this.form.notInUnidadeAdministrativa = notInUnidadeAdministrativa;
            this.load();
        },
        selectFillhoClicked(valor) {
            this.form.incluirFilhos = valor;
            this.load();
        },

        gerarFiltro() {
            this.params = {}

            this.params.notInUnidadeAdministrativa = this.form.notInUnidadeAdministrativa;

            this.params.incluirFilhos = this.form.incluirFilhos;

            if (this.codsDepartamentos != "") {
                this.params.codsDepartamentos = this.codsDepartamentos;
            }

            this.params.numTombamentoDe = null
            this.params.numTombamentoAte = null
            this.params.numTombamento = null

            if (
                this.form.numTombamento &&
                this.form.numTombamento != ""
            ) {
                if (
                    this.form.numTombamentoAte &&
                    this.form.numTombamentoAte != ""
                ) {
                    this.params.numTombamentoDe = this.form.numTombamento
                    this.params.numTombamentoAte = this.form.numTombamentoAte
                } else {
                    this.params.numTombamentoDe = this.form.numTombamento
                }
            }

            if (this.tombamento && this.tombamento != "") {
                this.params.numTombamento = this.tombamento
            }


            this.params.numTombamentoSAMP = null
            if (this.form.numTombamentoSamp) {
                this.params.numTombamentoSAMP = this.form.numTombamentoSamp
            }

            if (this.form.dataDe) {
                this.params.dataInicio = moment(String(this.form.dataDe)).format(
                    "DD/MM/YYYY"
                )
            }
            if (this.form.dataAte) {
                this.params.dataFim = moment(String(this.form.dataAte)).format(
                    "DD/MM/YYYY"
                )
            }


            if (this.form.departamento) {
                this.params.departamentoId = this.form.departamento.id;
            }

            this.params.descricao = null
            if (this.form.descricaoProduto) {
                this.params.descricao = this.form.descricaoProduto
            }

            this.params.descricaoExata = this.form.descricaoExata

            if (this.form.produto && Object.keys(this.form.produto).length > 0) {
                this.params.produtoId = this.form.produto
            }

            if (this.form.status && this.form.status.id) {
                this.params.statusId = this.form.status.id
            }

            this.params.numeroProduto = null
            if (this.form.numero) {
                this.params.numeroProduto = this.form.numero
            }

        },

        async load() {
            this.busy = true

            this.gerarFiltro();
            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.params,
            })
            this.busy = false
        },
        async visualizarItemBemPermanente(item) {
            this.$router.push({
                name: "visualizarItemBemPermanente",
                params: { id: item.id },
            })
        },
        async removerResource(item) {
            this.$removeResource(item)
        },
        async statusList({ filter, page = 1 }) {
            return this.$serviceStatus.findAll({ filter, page, limit: 5 })
        },
        async listStatus({ filter, page = 1 }) {
            return this.$statusService.findAll({ filter, page, limit: 5 })
        },
        clearForm() {
            this.codsDepartamentos = "";
            this.form.numTombamento = ""
            this.form.dataDe = ""
            this.form.dataAte = ""
            this.form.numTombamentoAte = ""
            this.form.numTombamentoSamp = ""
            this.form.numero = ""
            this.tombamento = ""
            this.form.descricaoExata = false
            this.form.descricaoProduto = ""
            this.form.status = {};

            this.params = {}
            const brand = JSON.parse(localStorage.getItem("context"))
            this.form.departamento = brand.departamento
            this.params.departamentoId = brand.departamento.id
            this.load()
        },
        showModal(item) {
            this.idItemBemPermanente = item.id;
            this.status = item.status;
            this.tombamento = item.numTombamento;
            this.mostrarModal = true;

            if (!this.imprimirTodos)
                this.gerarImagemEtiqueta();
        },

        fecharModal() {
            this.status = '';
            this.tombamento = '';
            this.etiquetaSrc = '';
            this.justificativa = "";
            this.imprimirTodos = false;
            this.mostrarModal = false;
            this.idItemBemPermanente = null;
            this.tombamento = "";
            this.impressora = {};
            this.load();
        },
        selectStatus(item) {
            this.form.status = item
            this.load()
        },
        departamentoSelect(item) {
            this.codsDepartamentos = "";
            this.form.departamento = item
            this.load()
        },
    },
}
</script>


<style scoped>
.text-danger {
    color: red;
}
</style>